import { render, staticRenderFns } from "./newsArticle.vue?vue&type=template&id=0cca9852&"
var script = {}
import style0 from "./newsArticle.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cca9852')) {
      api.createRecord('0cca9852', component.options)
    } else {
      api.reload('0cca9852', component.options)
    }
    module.hot.accept("./newsArticle.vue?vue&type=template&id=0cca9852&", function () {
      api.rerender('0cca9852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/newsArticle/newsArticle.vue"
export default component.exports